import React from 'react'
import { NumberText } from '../../../Global'

export const TableDataCellPurchases = ({
  dataValue,
}: {
  dataValue?: number
}) => {
  return <NumberText value={Number(dataValue)} />
}
